var app = angular.module('leonardo');

let UserRolesService = function(BaseRestService) {
  return new BaseRestService('user-roles');
};

app.factory('UserRolesService', ['BaseRestService', UserRolesService]);
